import { ChartType } from "../../Component/Model/Enum/ChartType";


const fullWidthCharts: Array<ChartType> = [
    ChartType.EmployeeHeadCountChart1DoubleColumnChart,
    ChartType.IncomeDifferentialGraph,
    ChartType.ATRCostAndHeadcountTrainingChart,
    ChartType.WSPCostAndHeadcountTrainingChart,
    ChartType.WorkforceProfileOfoMajorGroupSummary
];

export const getChartColumnWidth = (chartType: ChartType, isEEPlanTrackingYear5: boolean): number => {

    if (fullWidthCharts.includes(chartType) || isEEPlanTrackingYear5) return 12;

    return 6;
}